const posId = {
	pos: {
		common: {
			notification: "Notifikasi",
			cancel: "Batal",
			save: "Simpan",
			decrease: "Kurangi",
			increase: "Tambah",
			backspace: "Hapus",
		},
		nav: {
			catalog: "Katalog",
			order: "Order/Simpan Pesanan",
			history: "Riwayat",
			settlement: "Rekap",
			expenses: "Pengeluaran",
			more: "Lainnya",
			dashboard: "Dashboard",
			menu: "Menu",
		},
		catalog: {
			search: "Cari produk...",
			manualOrder: "Pesanan Manual",
			listView: "Tampilan daftar",
			gridView: "Tampilan grid",
			allProducts: "Semua Produk",
			notFound: "Produk tidak ditemukan.",
			loading: "Memuat produk...",
			loadFailed: "Gagal memuat produk.",
			retry: "Coba lagi",
			variant: "{count} Varian",
			outOfStock: "Stok habis",
			stockLimit: "Stok '{name}' tersisa {stock}",
		},
		variant: {
			subtitle: "{count} varian produk",
			save: "Simpan",
		},
		panel: {
			title: "Detail Pesanan",
			add: "Tambah",
			addNote: "+ Catatan",
			addDiscount: "+ Diskon",
			addOrderDiscount: "+ Tambah Diskon",
			discountTitle: "Tambah Diskon",
			discountItemTitle: "Diskon · {name}",
			discountBase: "Dasar: {amount}",
			discountTypePercent: "Diskon (%)",
			discountTypeFixed: "Nominal (Rp)",
			removeDiscount: "Hapus Diskon",
			addCategoryDiscount: "+ Diskon Kategori",
			removeCategoryDiscount: "Hapus Diskon Kategori",
			categoryDiscount: "Diskon Kategori",
			promoDiscount: "Diskon Promo",
			itemNotePlaceholder: "Catatan item",
			discountPlaceholder: "Diskon (Rp)",
			discountLabel: "Diskon",
			subtotal: "Sub total",
			orderDetails: "Rincian Pesanan",
			addDiscountButton: "Tambah diskon",
			transactionNotePlaceholder: "Tulis catatan untuk transaksi ini",
			tax: "Pajak & Surcharge {percent}%",
			rounding: "Pembulatan",
			total: "Total",
			transactionNote: "Catatan transaksi (Opsional)",
			paymentMethod: "Metode Pembayaran",
			choosePayment: "Pilih metode",
			changePayment: "Ubah",
			emptyTitle: "Belum ada item",
			emptyDesc: "Pilih produk di sebelah kiri untuk mulai membuat pesanan.",
			deleteOrder: "Hapus Pesanan",
			payNow: "Bayar Sekarang",
			saveOrder: "Simpan pesanan",
			itemCount: "{count} item",
			wholesale: "Grosir",
			noteChip: "Catatan",
			discountChip: "Diskon",
		},
		payment: {
			title: "Pembayaran",
			methodTitle: "Pilih Metode Pembayaran",
			totalBill: "Total tagihan {amount}",
			methodSubtitle: "Metode {method} · Total {amount}",
			groupCash: "Tunai",
			groupCashless: "Non-Tunai",
			choose: "Pilih",
			customer: "Pelanggan",
			addCustomer: "Tambah Pelanggan",
			points: "{count} Poin",
			cashReceived: "Uang Diterima",
			exactAmount: "Uang Pas",
			payCash: "Bayar Tunai · {amount}",
			pay: "Bayar",
			cardNumber: "Nomor Kartu",
			cardNumberPlaceholder: "Masukkan 16 digit nomor kartu",
			scan: "Scan",
			scanTitle: "Scan Kartu Siswa",
			scanSubtitle: "Pindai QR / barcode kartu siswa",
			scanHint:
				"Posisikan QR / barcode kartu di dalam bingkai. Pemindaian berjalan otomatis saat kartu terdeteksi.",
			scannerActive: "Barcode Scanner Aktif",
			rfidActive: "RFID Reader Aktif",
			manualInput: "Input manual nomor kartu",
			cancel: "Batal",
			pinTitle: "Masukkan PIN Kartu",
			forgotPin: "Lupa PIN?",
			wrongPin: "PIN salah. Coba lagi.",
			processing: "Memproses...",
			loading: "Memuat...",
			payAmount: "Bayar · {amount}",
			customerTitle: "Pilih Pelanggan",
			customerSubtitle: "{count} pelanggan tersimpan",
			customerSearch: "Cari nama atau nomor HP…",
			customerCard: "CARD · {number}",
			customerEmpty: "Pelanggan tidak ditemukan.",
			customerNew: "Tambah Pelanggan Baru",
			customerNewSubtitle: "Pelanggan baru langsung dipilih setelah disimpan",
			customerName: "Nama Pelanggan",
			customerNamePlaceholder: "Contoh: Bu Sari",
			customerPhone: "Nomor HP",
			customerEmail: "Email (opsional)",
			customerAdded: "Pelanggan {name} ditambahkan",
			customerRequired: "Pelanggan (wajib)",
			cardType: "Jenis Kartu",
			cardTypeDebit: "Debit",
			cardTypeCredit: "Kredit",
			bank: "Bank Penerbit",
			bankPlaceholder: "Pilih bank...",
			cardLast4: "Nomor Kartu",
			cardLast4Placeholder: "Masukkan 4 digit terakhir nomor kartu",
			cardLast4Hint: "Hanya angka untuk pencatatan saja",
			cardHolder: "Nama pada Kartu",
			cardHolderPlaceholder: "Nama sesuai kartu",
			debitRecordOnly:
				"Field di bawah hanya untuk pencatatan, sistem tidak memproses transaksi EDC.",
			dueDate: "Tenggat Waktu",
			dueDatePlaceholder: "Pilih tanggal jatuh tempo",
			dueDateRequired: "Tenggat Waktu wajib diisi.",
			customerRequiredError: "Pelanggan wajib dipilih.",
			downPayment: "Uang Muka (DP)",
			receivedOptional: "Uang yang Diterima (Opsional)",
			receivedPlaceholder: "Masukkan nominal uang diterima",
			receivedLabel: "Uang Diterima",
			dpNoChange: "Pembayaran sebagian (DP) tidak ada kembalian",
			remaining: "Sisa Hutang",
			noteTitle: "Catatan",
			hutangNote:
				"Hutang tercatat berstatus Belum Lunas dan masuk Riwayat Hutang untuk dilunasi kemudian.",
			unpaidShort: "Belum Lunas",
			finishTransaction: "Selesaikan Transaksi",
			saveHutang: "Simpan Hutang",
			preorderInfo:
				"Pesanan disimpan sebagai Pre Order (status Pending) tanpa menagih pembayaran. Bayar kemudian via Riwayat Pre Order.",
			preorderNote: "Catatan (Opsional)",
			preorderNotePlaceholder: "Contoh: diambil besok jam 10.00",
			statusLabel: "Status",
			pendingShort: "Pending",
			noteCounter: "{count}/{max}",
			savePreorder: "Simpan Pre Order",
			qrisTitle: "Pembayaran QRIS",
			qrisGenerating: "Membuat kode QR...",
			qrisWaiting: "Menunggu Pembayaran",
			qrisTotal: "Total Pembayaran",
			qrisLocked: "Nominal terkunci · Close Payment",
			qrisNmid: "NMID {nmid}",
			qrisHint:
				"Pindai kode QR menggunakan aplikasi e-wallet atau m-banking apa pun untuk menyelesaikan pembayaran.",
			qrisCheckStatus: "Cek Status Pembayaran",
			qrisChecking: "Mengecek status...",
			qrisStillPending: "Pembayaran belum diterima. Coba lagi.",
			recordOnly:
				"Pembayaran {method} diterima di luar sistem. Transaksi hanya dicatat.",
			confirmPayment: "Konfirmasi Pembayaran",
			successTitle: "Pembayaran Berhasil!",
			unpaidTitle: "Hutang Tercatat",
			pendingTitle: "Menunggu Pembayaran",
			successDesc: "Transaksi #{invoice} berhasil dibayar via {method}",
			recordedDesc: "Transaksi #{invoice} dicatat via {method}",
			pointsEarned: "+ {points} Poin diperoleh {name}",
			successBadge: "Sukses",
			unpaidBadge: "Hutang",
			pendingBadge: "Menunggu",
			totalTransaction: "Total Transaksi",
			cashTendered: "Tunai Diterima",
			walletPayment: "Pembayaran {wallet}",
			change: "Kembalian",
			sendReceipt: "Kirim Struk",
			viewReceipt: "Lihat Struk",
			printReceipt: "Cetak Struk",
			printerSettings: "Atur Printer",
			newOrder: "Tambah Pesanan Baru",
			redeemTitle: "Tukar Poin",
			redeemOption: "{points} Poin · {reward}",
		},
		manual: {
			title: "Pesanan Manual",
			subtitle: "Tambah item bebas tanpa produk tersimpan",
			productName: "Nama Produk",
			productNamePlaceholder: "Contoh: Kue ulang tahun custom",
			price: "Harga",
			qty: "Jumlah",
			addToOrder: "Tambah ke Pesanan",
		},
		scan: {
			title: "Scan Produk",
			subtitle: "Pindai barcode / QR produk untuk menambah pesanan",
			hint: "Arahkan kamera ke barcode produk. Scanner USB/Bluetooth juga aktif di halaman ini.",
			added: "{name} ditambahkan",
			notFound: "Produk dengan kode {code} tidak ditemukan",
			cameraStarting: "Menyalakan kamera...",
			cameraUnavailable:
				"Kamera / pemindai tidak tersedia di browser ini. Gunakan scanner USB atau input manual.",
		},
		receipt: {
			title: "Struk",
			thanks: "Terima kasih!",
			send: "Kirim",
			sent: "Struk berhasil dikirim via email",
			sendSubtitle: "Struk dikirim sebagai lampiran PDF ke email ini.",
			customerEmail: "Email pelanggan",
			cashier: "Kasir {name}",
			print: "Cetak Struk",
			printing: "Mencetak struk...",
		},
		held: {
			title: "Simpan Pesanan",
			subtitle: "Simpan keranjang untuk dilanjutkan nanti",
			namePlaceholder: "Nama pesanan (contoh: Meja 4 / Bu Sari)",
			saved: "Pesanan {name} disimpan",
			badge: "Tersimpan",
			resume: "Lanjutkan",
			pay: "Bayar",
			pending: "Pending",
			emptyTitle: "Belum ada pesanan",
			emptyDesc:
				"Pesanan yang disimpan dari halaman Katalog akan muncul di sini.",
			cartNotEmpty:
				"Keranjang masih berisi pesanan. Selesaikan atau kosongkan dulu.",
		},
		printer: {
			title: "Atur Printer",
			paperSize: "Ukuran Kertas",
			hint: "Pastikan printer menyala dan terhubung ke perangkat kasir.",
		},
		split: {
			title: "Split Bill",
			pageTitle: "Split Bill '{name}'",
			remaining: "Sisa {qty} {unit}",
			backToOrder: "Kembali ke Order",
			subtotal: "Subtotal",
			subtitle: "Pilih jumlah item yang dibayar sekarang",
			namePlaceholder: "Nama pesanan sisa (contoh: Meja 4 - sisa)",
			payNow: "Dibayar Sekarang",
			confirm: "Bayar & Simpan Sisa",
			done: "Sisa pesanan disimpan sebagai {name}",
			badge: "Split Bill",
		},
		history: {
			tabOrder: "Order",
			tabPreorder: "Pre Order",
			tabDebt: "Hutang",
			tabExpenses: "Pengeluaran",
			searchPlaceholder: "Cari Ref ID / nama produk…",
			startDate: "Tanggal mulai",
			endDate: "Tanggal akhir",
			allPayments: "Semua Metode",
			empty: "Belum ada transaksi pada periode ini.",
			loadMore: "Muat lebih banyak",
			manageExpenses: "Kelola Pengeluaran",
			unpaidAmount: "{amount} belum dibayar",
			noteLabel: "Catatan",
			statusSuccess: "Sukses",
			statusSettled: "Lunas",
			statusNotSettled: "Belum Lunas",
			statusPending: "Pending",
			statusCanceled: "Dibatalkan",
			statusFailed: "Gagal",
			copied: "Ref ID disalin",
			detailSubtitle: "Detail Transaksi",
			dateLabel: "Tanggal & Waktu",
			systemDiscount: "Diskon Promo",
			taxLabel: "Pajak",
			itemsTitle: "Rincian Pesanan",
			paymentsTitle: "Riwayat Pembayaran",
			cancelAction: "Batalkan Transaksi",
			cancelTitle: "Batalkan Transaksi",
			cancelSubtitle: "Masukkan alasan pembatalan dan PIN kasir",
			cancelReasonPlaceholder: "Alasan pembatalan",
			cancelPinPlaceholder: "PIN kasir",
			cancelConfirm: "Batalkan Transaksi",
			cancelDone: "Transaksi berhasil dibatalkan",
			cancelReasonLabel: "Alasan Pembatalan",
			payDebtAction: "Bayar Hutang",
			payDebtTitle: "Bayar Hutang",
			payDebtSubtitle: "Sisa hutang {amount}",
			payDebtTooMuch: "Nominal melebihi sisa hutang.",
			payDebtConfirm: "Bayar · {amount}",
			payDebtDone: "Pembayaran hutang tercatat",
			payPreorderAction: "Bayar Pre Order",
		},
		settlement: {
			tabRecap: "Rekap",
			tabHistory: "Riwayat Rekap",
			sale: "Penjualan",
			totalSale: "Total penjualan",
			qtySale: "Jumlah penjualan",
			qtySaleValue: "{qty} Transaksi",
			cashTransaction: "Transaksi Tunai",
			initialCash: "Modal awal",
			cashPayment: "Pembayaran tunai",
			topupPpob: "Pembayaran (Top Up & PPOB)",
			paymentDebt: "Pembayaran hutang",
			expenses: "Pengeluaran",
			withdrawCardExpenses: "Penarikan saldo kartu",
			canceledTransaction: "Transaksi dibatalkan",
			total: "Total",
			nonCashTransaction: "Transaksi Non-Tunai",
			entryDischarge: "Debit masuk",
			eWallet: "E-Wallet",
			transferBank: "Transfer bank",
			entryBalance: "Saldo masuk",
			outBalance: "Saldo keluar (Top Up, PPOB & Refund Kartu)",
			debt: "Hutang",
			debtGiven: "Hutang diberikan",
			otherCosts: "Biaya Lainnya",
			discount: "Diskon",
			fee: "Biaya",
			tax: "Pajak",
			setInitialCash: "Atur Modal Awal",
			amountCash: "Jumlah Uang Tunai",
			set: "Simpan",
			setCashDone: "Modal awal berhasil disimpan",
			startRecap: "Mulai Rekap",
			recapTitle: "Rekap Kas",
			recapSubtitle: "Hitung uang fisik di laci lalu proses rekap",
			nonCashAmount: "Total non-tunai",
			notes: "Catatan",
			process: "Proses Rekap",
			recapDone: "Rekap berhasil diproses",
			empty: "Belum ada data rekap.",
			from: "Dari",
			to: "Sampai",
			cashSystem: "Kas menurut sistem",
			settlementCash: "Kas saat rekap",
			difference: "Selisih",
			cashierLabel: "Kasir",
			detailTitle: "Detail Rekap",
		},
		expenses: {
			viewHistory: "Lihat Riwayat",
			category: "Kategori",
			defaultCategory: "Umum",
			manageCategories: "Kelola Kategori",
			name: "Nama Pengeluaran",
			namePlaceholder: "Contoh: Beli galon air",
			amount: "Nominal",
			date: "Tanggal",
			notes: "Catatan (Opsional)",
			notesPlaceholder: "Catatan tambahan",
			save: "Simpan Pengeluaran",
			saved: "Pengeluaran berhasil disimpan",
			categoriesTitle: "Kategori Pengeluaran",
			categoriesSubtitle: "Tambah atau hapus kategori",
			noCategories: "Belum ada kategori khusus.",
			newCategoryPlaceholder: "Nama kategori baru",
			addCategory: "Tambah",
			categoryAdded: "Kategori {name} ditambahkan",
			categoryDeleted: "Kategori {name} dihapus",
			deleteCategory: "Hapus kategori",
		},
		more: {
			dashboard: "Dashboard",
			products: "Produk",
			paperHint: "Lebar kertas struk untuk pencetakan",
			paperOption: "{size} mm",
			cardSystem: "Cazh Cards",
			cardCheck: "Cek Kartu",
			cardActivate: "Aktivasi Kartu",
			cardTopUp: "Isi Kartu",
			cardWithdraw: "Tarik Saldo Kartu",
			billing: "Tagihan",
			pulsa: "Pulsa",
			cellularData: "Data Seluler",
			pln: "PLN",
			pdam: "PDAM",
			comingSoon: "{name} belum tersedia",
		},
		card: {
			checkTitle: "Cek Kartu",
			searchCard: "Cari kartu",
			searchPlaceholder: "Masukkan nama atau nomor kartu",
			orLabel: "atau",
			scanQR: "Scan QR Code",
			scanHint: "Arahkan kamera ke QR code pada kartu",
			nfcWaiting: "Menunggu kartu didekatkan ke reader",
			nfcTapNow: "Tempelkan kartu ke perangkat",
			nfcUnavailable: "Reader NFC tidak tersedia di perangkat ini",
			nfcReaderOff: "Reader Tidak Aktif",
			transactionLimit: "Limit Transaksi",
			transactionLimitLeft: "Sisa Limit Transaksi",
			withdrawLimit: "Limit Penarikan",
			withdrawLimitLeft: "Sisa Limit Penarikan",
			perDay: "{amount} / hari",
			walletsTitle: "Dompet Kartu",
			tapNFC: "Tap Kartu (NFC)",
			check: "Cek Kartu",
			checking: "Memeriksa...",
			back: "Kembali",
			balance: "Saldo",
			cardBlocked: "Kartu terblokir",
			cardInactive: "Kartu belum aktif",
			cardNonaktif: "Kartu nonaktif",
			cardActive: "Kartu sudah aktif.",
			cardNotFound: "Kartu tidak ditemukan. Periksa nomor kartu.",
			cardDetected: "Kartu berhasil terdeteksi",
			cardNotRecognized: "Kartu tidak terdaftar di sistem",
			detailTitle: "Detail Kartu",
			cardNumber: "Nomor Kartu",
			holderName: "Nama Pemegang",
			phone: "No. HP",
			email: "Email",
			activatedAt: "Tanggal Aktivasi",
			status: "Status",
			statusActive: "Aktif",
			statusInactive: "Belum Aktif",
			statusBlocked: "Diblokir",
			checkOtherCard: "Cek Kartu Lain",
			activateTitle: "Aktivasi Kartu",
			fullName: "Nama Lengkap",
			fullNamePlaceholder: "Nama lengkap pemegang kartu",
			phoneNumber: "Nomor HP",
			phonePlaceholder: "Contoh: 08123456789",
			emailPlaceholder: "Contoh: email@domain.com",
			regionCode: "Kode Wilayah",
			activate: "Aktivasi",
			activating: "Mengaktivasi...",
			activateSuccess: "Kartu berhasil diaktivasi",
			activateFailed: "Gagal mengaktivasi kartu",
			warningTitle: "Peringatan",
			activateWarning:
				"Pastikan data yang dimasukkan benar. Data tidak dapat diubah setelah aktivasi.",
			topUpTitle: "Isi Kartu",
			selectWallet: "Pilih Dompet",
			amount: "Nominal",
			amountPlaceholder: "Masukkan nominal",
			cashierPin: "PIN Kasir",
			cashierPinPlaceholder: "Masukkan PIN kasir",
			notes: "Catatan (Opsional)",
			notesPlaceholder: "Catatan tambahan",
			topUpFee: "Biaya Isi Kartu",
			topUp: "Isi Saldo",
			toppingUp: "Mengisi saldo...",
			topUpSuccess: "Pengisian saldo berhasil",
			topUpFailed: "Gagal mengisi saldo",
			topUpResultTitle: "Isi Kartu Berhasil",
			topUpResultSubtitle: "Simpan struk ini sebagai bukti isi kartu",
			close: "Tutup",
			withdrawTitle: "Tarik Saldo",
			withdrawSubtitle: "Tarik saldo dari dompet kartu",
			cardPin: "PIN Kartu",
			cardPinPlaceholder: "Masukkan PIN kartu",
			withdraw: "Tarik Saldo",
			withdrawing: "Menarik saldo...",
			withdrawSuccess: "Penarikan saldo berhasil",
			withdrawFailed: "Gagal menarik saldo",
		},
		placeholder: {
			desc: "Halaman ini masih dalam pengembangan. Lihat docs/prd/POS_TRANSACTION.md.",
		},
	},
};

export default posId;
